// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './filterType.scss'
import classNames from 'classnames'
import checkIcon from '../../../images/common/success-filled.svg'

interface Props {
  name: string
  setFilter: (name: string) => void
  isSelected: boolean
  disabled: boolean
}

export const FilterType = ({ name, setFilter, isSelected, disabled }: Props) => (
  <div
    role='presentation'
    onMouseDown={(e) => {
      e.preventDefault()
      if (disabled) return
      setFilter(name)
    }}
    className={classNames('filter-selector', {
      'is-selected': isSelected,
      'filter-selector-disabled': disabled,
    })}>
    <div>{name}</div>
    {isSelected ?
      <img className='filter-selector-check-icon' src={checkIcon} alt='Check icon' />
    : null}
  </div>
)
